import { Pipe, PipeTransform } from '@angular/core';
import { KeyValue } from '@angular/common';
import { FormlyFieldConfig, FormlyFieldProps } from '@ngx-formly/core';
import { find, map, startsWith } from 'lodash';
import { Observable, of } from 'rxjs';
import { FormlySelectOption } from '@ngx-formly/core/select';

@Pipe({
  name: 'fieldMeta',
  standalone: true,
})
export class FieldMetaPipe implements PipeTransform {
  transform(pair: KeyValue<any, any>, fields: FormlyFieldConfig[]): any {
    const field: any = find(fields, { key: pair.key }) as FormlyFieldConfig;

    if (startsWith(pair.key, '__') || !field) {
      return undefined;
    }

    return {
      type: this.getFieldType(field.props.displayAs ?? (field.type as string)),
      heading: field.props.heading,
      label: field.props.label,
      addonLeft: field.props.addonLeft,
      addonRight: field.props.addonRight,
      decimalFormat: field.props.decimalFormat,
      options$: this.getFieldOptions$(field.props),
      calcTableMeta:
        field.type === 'calc-table' ? this.getCalcTableMeta(field) : null,
      displayWith: field.props.displayWith,
      required: field.props.required,
      hidden:
        field.props.summaryHidden ||
        (!field.props.required && !pair.value && pair.value !== 0),
    };
  }

  private getFieldOptions$(
    props: FormlyFieldProps
  ): Observable<FormlySelectOption[]> {
    if (props.options instanceof Observable) {
      return props.options;
    }

    return of(props.options || []);
  }

  private getFieldType(type: string): string {
    switch (type) {
      case 'input':
      case 'textarea':
        return 'string';

      case 'image-file-input':
        return 'file';

      case 'datepicker':
        return 'date';

      default:
        return type;
    }
  }

  private getCalcTableMeta(field: any) {
    return {
      headers: map(
        field?.props?.tableRows[0]?.fields,
        (row) => row.props.label
      ),
      rows: map(field?.props?.tableRows, (row) => ({
        label: row.label,
        fields: map(row.fields, 'key'),
      })),
      summary: field?.props?.summary,
    };
  }
}
